import { render, staticRenderFns } from "./Recorder.vue?vue&type=template&id=d222058e&scoped=true"
import script from "./Recorder.vue?vue&type=script&lang=js"
export * from "./Recorder.vue?vue&type=script&lang=js"
import style0 from "./Recorder.vue?vue&type=style&index=0&id=d222058e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d222058e",
  null
  
)

export default component.exports